<div class="my-3 d-flex justify-content-end">
	<button mat-raised-button color="primary" class="me-2" (click)="accordion().openAll()">Rozwiń wszystko</button>
	<button mat-raised-button color="warn" (click)="accordion().closeAll()">Zwiń wszystko</button>
</div>

<mat-accordion multi>
	<app-product-expansion-panel-template
		[panelTitle]="cardsDialogConfig.title"
		[addDialogConfig]="cardsDialogConfig"
		(emitDialogResult)="updateProduct($event)"
	>
		<app-product-mat-table-template
			[dataSource]="cards"
			[tableTemplate]="cardsTableTemplate"
			[dialogConfig]="cardsDialogConfig"
			(emitEditDialogResult)="updateProduct($event)"
		></app-product-mat-table-template>
	</app-product-expansion-panel-template>
	<app-product-expansion-panel-template
		[panelTitle]="hotelsDialogConfig.title"
		[addDialogConfig]="hotelsDialogConfig"
		(emitDialogResult)="updateProduct($event)"
	>
		<app-product-mat-table-template
			[dataSource]="hotels"
			[tableTemplate]="hotelsTableTemplate"
			[dialogConfig]="hotelsDialogConfig"
			(emitEditDialogResult)="updateProduct($event)"
		></app-product-mat-table-template>
	</app-product-expansion-panel-template>
	<app-product-expansion-panel-template
		[panelTitle]="guidesDialogConfig.title"
		[addDialogConfig]="guidesDialogConfig"
		(emitDialogResult)="updateProduct($event)"
	>
		<app-product-mat-table-template
			[dataSource]="guides"
			[tableTemplate]="guidesTableTemplate"
			[dialogConfig]="guidesDialogConfig"
			(emitEditDialogResult)="updateProduct($event)"
		></app-product-mat-table-template>
	</app-product-expansion-panel-template>
	<app-product-expansion-panel-template
		[panelTitle]="ticketsDialogConfig.title"
		[addDialogConfig]="ticketsDialogConfig"
		(emitDialogResult)="updateProduct($event)"
	>
		<app-product-mat-table-template
			[dataSource]="tickets"
			[tableTemplate]="ticketsTableTemplate"
			[dialogConfig]="ticketsDialogConfig"
			(emitEditDialogResult)="updateProduct($event)"
		></app-product-mat-table-template>
	</app-product-expansion-panel-template>
</mat-accordion>
